import { Box } from "@mui/material";
import { PhoneField } from "@src/appV2/lib";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

interface VerifyPhoneFormProps {
  onSubmit: (values: { phoneNumber: string }) => Promise<void>;
  id: string;
}

export function VerifyPhoneForm(props: VerifyPhoneFormProps) {
  const { onSubmit, id } = props;
  const { handleSubmit, setError } = useFormContext<{ phoneNumber: string }>();

  const handleMaxLengthAttempt = useCallback(() => {
    setError("phoneNumber", {
      type: "manual",
      message: "Phone number cannot be more than 10 digits.",
    });
  }, [setError]);

  return (
    <Box
      component="form"
      id={id}
      sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}
      onSubmit={handleSubmit(async (formData) => {
        await onSubmit(formData);
      })}
    >
      <Text sx={{ pb: 1 }}>Please enter your phone number to verify your account.</Text>
      <PhoneField
        showLabel={false}
        name="phoneNumber"
        onMaxLengthAttempt={handleMaxLengthAttempt}
      />
    </Box>
  );
}
